import { useBoolean } from '@csp/fe-hooks';
import { useEffect } from 'react';

export const useIsBrowserTabActive = (): boolean => {
  const [isActive, setIsActive, setIsNotActive] = useBoolean(true);

  const registerWindowEventListeners = (): void => {
    window.addEventListener('focus', setIsActive);
    window.addEventListener('blur', setIsNotActive);
  };

  const removeWindowEventListeners = (): void => {
    window.removeEventListener('focus', setIsNotActive);
    window.removeEventListener('blur', setIsNotActive);
  };

  useEffect(() => {
    registerWindowEventListeners();

    return removeWindowEventListeners;
    // eslint-disable-next-line
  }, []);

  return isActive;
};
